<template>
  <v-container>
    <div class="title-icon">
      <h1>{{ $t('order-card.thankyou-title') }}</h1>
    </div>
    <p>
      {{ $t('order-card.thankyou-p1') }}
    </p>
    <p v-if="$route.params && $route.params.type && $route.params.type=='tradecertificate-card'">
      {{ $t('order-card.thankyou-p3') }}
    </p>
    <p v-else>
      {{ $t('order-card.thankyou-p2') }}
    </p>
  </v-container>
</template>


<script>
export default {}
</script>

<style lang="scss" scoped>
</style>